import SummarizeIcon from '@mui/icons-material/Summarize';
import { Box, Grid, MenuItem, Popover, TextField, Theme, Typography, FormControlLabel, Checkbox } from '@material-ui/core';
import MailIcon from '@mui/icons-material/Mail';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import HistoryIcon from '@mui/icons-material/History';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import { createStyles, makeStyles } from '@material-ui/styles';
import { LoadingButton } from 'common/components/buttons/LoadingButton';
import Customer, { CustomerNameObject, CustomerPhone, CustomerTags } from 'common/models/customer';
import { useFormik } from 'formik';
import React, { forwardRef, ReactElement, Ref, useEffect, useImperativeHandle, useState } from 'react';
import MaskedInput from 'react-text-mask';
import * as Yup from 'yup';
import Chip from '@mui/material/Chip';
import AddIcon from '@mui/icons-material/Add';
import { useAppDispatch, useAppSelector } from 'app';
import CustomerInvoiceDrawer from 'components/customer-groups/components/customer-group/customers-table/customer-invoice/';
import MessengerDrawer from 'components/messaging/components/messenger-drawer';
import CustomerContacts from '../customerContact';
import OwnedUnitsDrawer from './CustomerOwnedUnit/OwnedUnitsDrawer';
import CustomerAPI, {
  CustomerCategory,
  CustomerEmailType,
  CustomerPhoneType,
  OwnedUnitsRequest, GetOwnedUnitsResponse
} from 'components/customer/api/CustomerAPI';

import moment from 'moment';
import StyleIcon from '@mui/icons-material/Style';
import DealerAPI from 'components/authentication/api/dealer-api';
import AppSnackBar from 'components/snackbar/snackbar';
import { TextMaskCustomProps } from './TextMaskCustomProps';
import { CustomerProps } from './CustomerProps';
import { CustomerNameComponent } from './CustomerNameComponent';
import { CustomerFormRef } from './CustomerFormRef';
import { CompanyName } from './CompanyName';
import { CustomerAddressList } from './CustomerAddressList';
import { SalesPerson } from './SalesPerson';
import { SurveyRating } from './SurveyRating';
import { Birthday } from './Birthday';
import { CustomerCategoryComponent } from './CustomerCategoryComponent';
import { JobTitle } from './JobTitle';
import { CustomerPhoneList } from './CustomerPhoneList';
import { CustomerEmailList } from './CustomerEmailList';
import { Notes } from './Notes';
import { DmsTypeEnum } from 'common/enums/DmsTypeEnum';
import { fetchSelectedCustomer } from '../Customers/customersSlice';
import AddNewDeal from 'components/deals/drawer/addNewDealDrawer';
import { showTaskDrawer } from 'components/lead/contexts/taskboardSlice';
import CustomerSettingsApi from 'components/setting/api/customer-settings-api';
import { CustomerTagOptions, CustomerTagTitle } from 'components/setting/models/customer-tag-title';
import CustomerTagPopover from '../Customers/CustomerTagPopover';
import { salesStages } from 'common/utils/salesStages';
import CustomerSummaryDrawer from '../CustomerSummary/CustomerSummaryDrawer';
import Dialog from '@mui/material/Dialog';
import { Backdrop, CircularProgress } from "@mui/material";
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
export const addressTypes = [
  {
    value: '1',
    label: 'Shipping',
  },
  {
    value: '2',
    label: 'Billing',
  },
];

export const TextMaskCustom = (props: TextMaskCustomProps) => {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={(ref: any) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      guide
      keepCharPositions
      mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      showMask
    />
  );
};

export const useStyles = makeStyles((theme: Theme): any =>
  createStyles({
    myTab: {
      border: '1px solid white',
      padding: '0px 5px',
      cursor: 'pointer',
      '&:hover': {
        border: '1px solid silver',
        color: 'green',
        // fontWeight: 'bold',
      },
    },
    root: {
      marginTop: 10,
      width: '80%',
      textAlign: 'center',
      backgroundColor: theme.palette.background.paper,
    },
    avatar: {
      backgroundColor: '#3f51b5',
    },
    successIcon: {
      color: theme.palette.success.main,
      fontSize: 12,
      paddingRight: 5,
      position: 'absolute',
      marginTop: 10,
      marginLeft: -15,
    },
    errorIcon: {
      color: theme.palette.error.main,
      fontSize: 12,
      paddingRight: 5,
      position: 'absolute',
      marginTop: 10,
      marginLeft: -15,
    },
    removeEmailButton: {
      marginTop: '10px',
      marginLeft: '10px',
    },
    iconButton: {
      background: '#1976D2',
      color: 'white',
      // marginTop: '3px',
      marginLeft: '5px',
      // padding: '2px',
      height: '20px',
      width: '20px',
      fontSize: '1rem',
      '&:hover': {
        backgroundColor: '#1976D2 !important',
        color: 'white !important',
      },
    },
    errorMsg: {
      color: '#e53935',
      fontSize: '12px',
      fontWeight: 400,
      letterSpacing: '-0.06px',
      paddingLeft: '10px',
      paddingTop: '3px',
    },
    flagIcon: {
      cursor: 'pointer',
      marginRight: '10px',
      marginTop: '2px',
    }
  }),
);

const CustomerForm = forwardRef(
  (
    { customer, onFormSubmit, onClose, disabled, btnDisabled, validate }: CustomerProps,
    ref: Ref<CustomerFormRef>,
  ): ReactElement => {
    useImperativeHandle(ref, () => ({
      CompareChanges: function (callback: any) {
        let startValue = initialValues;
        startValue.customerCategories = [];
        let endValue = formik.values;
        endValue.customerCategories = [];

        if (endValue.customerNumber === 0)
          startValue.customerNumber = 0;

        if (startValue.name === null)
          startValue.name = '';
        if (startValue.firstName === null)
          startValue.firstName = '';
        if (startValue.middleName === null)
          startValue.middleName = '';
        if (startValue.lastName === null)
          startValue.lastName = '';

        if (endValue.name === null)
          endValue.name = '';
        if (endValue.firstName === null)
          endValue.firstName = '';
        if (endValue.middleName === null)
          endValue.middleName = '';
        if (endValue.lastName === null)
          endValue.lastName = '';

        let initial = JSON.stringify(startValue);
        let current = JSON.stringify(endValue);
        if (initial !== current) {
          callback(true);
        } else {
          callback(false);
        }
        return;
      },
      SubmitForm: function () {
        setIsFormSubmitted(true);
        formik.submitForm();
      },
    }));
    const classes: any = useStyles();
    const dispatch = useAppDispatch();
    const [showSnackBar] = AppSnackBar.useSnackBar();

    const [phoneTypes, setPhoneTypes] = useState<CustomerPhoneType[]>([]);
    const [emailTypes, setEmailTypes] = useState<CustomerEmailType[]>([]);
    const [categories, setCategories] = useState<CustomerCategory[]>([]);
    const [defaultCatLoader, setDefaultCatLoader] = useState(false);
    const [phoneEmailLoader, setPhoneEmailLoader] = useState(false);
    const [openInvoiceDrawer, SetOpenInvoiceDrawer] = React.useState<boolean>(false);
    const [openMessengerDrawer, SetOpenMessengerDrawer] = React.useState<boolean>(false);
    const [openContactDrawer, SetOpenContactDrawer] = React.useState<boolean>(false);
    const dmsDealerIdCrm = useAppSelector((state) => state.user.dmsDealerId);
    const [openSummaryDrawer, SetOpenSummaryDrawer] = React.useState<boolean>(false);
    const [summaryCount, SetSummaryCount] = React.useState<number>(0);
    const [isCustomerNumberUnique, SetisCustomerNumberUnique] = React.useState<boolean>(true);
    const [popoverChipState, setPopoverChipState] = useState<any>({ openedPopoverId: null, anchorEl: null });
    const [customerTags, setCustomerTags] = useState<CustomerTagTitle[]>([]);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [openAddDealDrawer, setOpenAddDealDrawer] = useState<boolean>(false);
    const [tagsLoading, setTagsLoading] = useState<boolean>(true);

    // new Drawer 
    const [openOwnedUnitsDrawer, setOpenOwnedUnitsDrawer] = useState(false);
    const [openNoUnitsDialog, setOpenNoUnitsDialog] = useState(false);
    const [loadingOwnedUnits, setLoadingOwnedUnits] = useState(false);

    const [shouldShowNoUnitsDialog, setShouldShowNoUnitsDialog] = useState(false);

    const handleOwnedUnitsClick = async () => {
      setLoadingOwnedUnits(true);
      try {
        const request: OwnedUnitsRequest = {
          pageNumber: 1,
          pageSize: 10,
          customerId: Number(customer?.customerId ?? 0),
        };

        const response = await CustomerAPI.getOwnedUnits(request);
        const fetchedUnits = response.units || [];

        if (fetchedUnits.length > 0) {
          setOpenOwnedUnitsDrawer(true);

          setShouldShowNoUnitsDialog(false);
        } else {
          setShouldShowNoUnitsDialog(true);
          setOpenOwnedUnitsDrawer(false);
        }
      } catch (err) {
        console.error("Failed to fetch owned units:", err);
        setShouldShowNoUnitsDialog(true);
        setOpenOwnedUnitsDrawer(false);
      } finally {
        setLoadingOwnedUnits(false);
      }
    };

    let dmsTypeId = useAppSelector((state) => state.user.dmsTypeId);
    const dealerId = useAppSelector((state) => state.user.dealerId);
    let userPermissions = useAppSelector((state) => state.user?.userPermissions);
    let isInvoicePermission = 0;
    let isMessengerPermission = 0;
    let isTaskPermission = 0;

    const schema = Yup.object<any>({
      customerNumber: (dmsTypeId == DmsTypeEnum.Aspen || dmsTypeId == DmsTypeEnum.DIS) ? Yup.string().max(15, 'Max 15 characters allowed.').required('Required').nullable() : undefined,
    });
    let editMode = false;
    let editDISMode = false;
    let initialValues: Customer = {
      crmCustomerId: 0,
      dealerId: 0,
      customerId: 0,
      organizationName: '',
      salesRepName: '',
      firstName: '',
      lastName: '',
      middleName: '',
      isOrganization: false,
      name: '',
      dob: '',
      customerAddresses: [],
      customerCategories: [],
      customerEmails: [],
      customerPhones: [],
      customerTags: [],
      conversationsPhoneIds: [],
      optIn: 1,
      optInEmail: false,
      optOutDate: '',
      notes: '',
      defaultPhoneType: -1,
      customerNumber: null,
      dateOfBirth: null,
      jobTitle: '',
      salesStageId: customer && customer.salesStageId ? customer.salesStageId : 0,
      defaultPhoneNumberForMessenger: '',
      reviewFlag: false,
      IsFacebookCustomer: false,
      FacebookCustomerId: null

    };
    if (customer !== undefined) {
      customer = { ...customer };
      if (dmsTypeId === DmsTypeEnum.Infinity) {
        customer.customerPhones = customer.customerPhones.filter((x) => x.contactId === 0 || x.contactId === null);
        customer.customerEmails = customer.customerEmails.filter((x: any) => x.contactId === 0 || x.contactId === null);
      }
      if (dmsTypeId === DmsTypeEnum.Ideal) {
        customer.customerEmails = customer.customerEmails.filter(
          (x: any) => customer && x.contactId === 0);
        customer.customerPhones = customer.customerPhones.filter(
          (x: any) => customer && x.contactId === 0);
      }

      if (!userPermissions) {
        userPermissions = [];
        isInvoicePermission = 2;
        isMessengerPermission = 2;
        isTaskPermission = 2;
      }
      if (isInvoicePermission == 0) {
        if (userPermissions.find((x) => x.featureName.toLowerCase() === 'invoice')) {
          isInvoicePermission = 1;
        }
      }

      if (isMessengerPermission == 0) {
        if (userPermissions.find((x) => x.featureName.toLowerCase() === 'messages')) {
          isMessengerPermission = 1;
        }
      }

      if (isTaskPermission == 0) {
        if (userPermissions.find((x) => x.featureName.toLowerCase() === 'tasks')) {
          isTaskPermission = 1;
        }
      }

      //Aspen
      if (dmsTypeId === DmsTypeEnum.Aspen) {
        customer.customerEmails = customer.customerEmails.filter(
          (x: any) => customer && (x.contactId === customer.primaryContactId || x.contactId === null),
        );
        customer.customerPhones = customer.customerPhones.filter(
          (x: any) => customer && (x.contactId === customer.primaryContactId || x.contactId === null),
        );
      }
      initialValues = { ...customer };
      editMode = true;

      if (dmsTypeId === DmsTypeEnum.DIS && customer?.customerId < 1) {
        editDISMode = true;
      }
    }
    else{
      editDISMode = true;
    }

    const formik = useFormik({
      initialValues,
      validationSchema: schema,
      onSubmit: (values: Customer) => {
        let phoneNumbers: CustomerPhone[] = [];
        if (values.customerPhones) {
          values.customerPhones.forEach((x) => {
            if (x.phoneNumber) {
              let p = {
                ...x,
                phoneNumber: x.phoneNumber.replace(/[^0-9]/g, ''),
              };
              if (dmsTypeId !== DmsTypeEnum.Aspen) {
                p.isPrimary = true;
              }
              phoneNumbers.push(p);
            }
          });
        }

        let customerNameObject: CustomerNameObject | undefined = undefined;
        customerNameObject = {
          customerNumber: values?.customerNumber || 0,
          firstName: values?.firstName || '',
          lastName: values?.lastName || '',
          middleName: values?.middleName || '',
          name: values?.name || '',
          jobTitle: values?.jobTitle,
          dateOfBirth: values?.dateOfBirth,
          contactId: -1,
        };

        const customerNameNotValidated = !validateCustomerName(customerNameObject)
        if (dmsTypeId === 1 && customerNameNotValidated) {
          formik.setFieldError('name', 'Customer Name is required')
          return;
        }
        if (dmsTypeId !== 1 && customerNameNotValidated && !formik.values.isOrganization) {
          formik.setFieldError('firstName', 'Customer First and Last Name Required')
          return;
        }

        if (dmsTypeId !== 1 && customerNameNotValidated && !formik.values.isOrganization) {
          formik.setFieldError('lastName', 'Customer First and Last Name Required')
          return;
        }
        if (dmsTypeId !== 1 && formik.values.isOrganization && !formik.values.organizationName) {
          formik.setFieldError('organizationName', 'Organization Name Required');
          return;
        }
        //For Aspen at least one phone/email should be default
        if (dmsTypeId == DmsTypeEnum.Aspen) {
          if (values.customerPhones.length > 0 && !values.customerPhones.find(x => x.isDefault == true)) {
            showSnackBar({ type: 'error', message: 'At least one phone should be Default.' });
            return;
          }
          if (values.customerEmails.length > 0 && !values.customerEmails.find(x => x.isDefault == true)) {
            showSnackBar({ type: 'error', message: 'At least one email should be Default.' });
            return;
          }
        }
        if (!isCustomerNumberUnique) {
          return;
        }
        if (dmsTypeId === DmsTypeEnum.Aspen && values.notes != null) {
          const notesAspen = values.notes.replace(/\n/g, ' ').replace(/  +/g, ' ');
          values.notes = notesAspen;
        }
        // code for search filter
        if (dmsTypeId === DmsTypeEnum.Aspen) {
          values.name = values.firstName + " " + values.lastName;
        }
        else if (dmsTypeId === DmsTypeEnum.Ideal) {
          values.name = values.lastName + ", " + values.firstName;
        }
        else if (dmsTypeId === DmsTypeEnum.DIS) {
          values.name = values.firstName + " " + values.lastName;
        }
        if (values.isOrganization && dmsTypeId !== 1) {
          values.name = '';
          values.firstName = '';
          values.middleName = '';
          values.lastName = '';
        }
        const sanitizedValues = { ...values, customerPhones: phoneNumbers };
        onFormSubmit(sanitizedValues);
        formik.resetForm();
      },
    });


     useEffect(() => {
      if (!openOwnedUnitsDrawer && shouldShowNoUnitsDialog) {
        const timer = setTimeout(() => {
          setOpenNoUnitsDialog(true);
          setShouldShowNoUnitsDialog(false);
          setOpenOwnedUnitsDrawer(false);
    }, 200); 
        return () => clearTimeout(timer);
       }
     }, [openOwnedUnitsDrawer, shouldShowNoUnitsDialog]);

    useEffect(() => {
      async function fetchCategories() {
        try {

          setDefaultCatLoader(true);
          const dealerSettingsResponse = await DealerAPI.getDealerSettings(dmsDealerIdCrm);
          const defaultCategoryId = dealerSettingsResponse.dealerLocationSettings.length > 0 && dealerSettingsResponse.dealerLocationSettings[0].defaultCustomerCategoryId;
          const categories = await CustomerAPI.getCategories(dealerId);
          setCategories(categories);
          if ((defaultCategoryId != null) && (defaultCategoryId.toString() != "")) {
            const cat = categories.find((x) => x.customerCategoryId.toString() === defaultCategoryId.toString());
            formik.values.customerCategories.length <= 0 && formik.setFieldValue('customerCategories', [cat])
          }
          else {
            formik.values.customerCategories.length <= 0 && formik.setFieldValue('customerCategories', [categories[0]]);
          }
          setDefaultCatLoader(false);
        } catch {
          setDefaultCatLoader(false);
        }
      }
      fetchCategories();
    }, []);

    useEffect(() => {
      async function fetchLookups() {
        try {
          setPhoneEmailLoader(true)
          setTagsLoading(true);
          const staticTags = await CustomerSettingsApi.getCustomerTags();
          setTagsLoading(false);
          setCustomerTags(staticTags);
          const phoneTypes = await CustomerAPI.getPhoneTypes(dealerId);
          const emailTypes = await CustomerAPI.getEmailTypes(dealerId);
          setEmailTypes(emailTypes);
          setPhoneTypes(phoneTypes);
          setPhoneEmailLoader(false)
        } catch {
          setPhoneEmailLoader(false)
        }
      }
      fetchLookups();
    }, []);

    async function reloadCustomerData(crmCustomerId: number) {
      dispatch(fetchSelectedCustomer(crmCustomerId));
    }

    function handleChipDelete(index: number) {
      let tags = [...formik.values.customerTags];
      tags.splice(index, 1);
      formik.setFieldValue('customerTags', tags);
    }
    const handlePopoverChipOpen = (event: any, popoverId: any) => {
      setPopoverChipState({
        openedPopoverId: popoverId,
        anchorEl: event.target,
      });
    };
    const handlePopoverChipClose = () => {
      setPopoverChipState({
        openedPopoverId: null,
        anchorEl: null,
      });
      const data = formik.values.customerTags.length - 1;
      if (formik.values.customerTags[data].tag === '') {
        let tags = [...formik.values.customerTags];
        tags.splice(data, 1);
        formik.setFieldValue('customerTags', tags);
      }
    };
    const addNewTAg = (event: any) => {
      let tags: any = [];

      if (formik.values.customerTags) {
        tags = [...formik.values.customerTags];
      }
      const customerTags: CustomerTags = {
        tag: '',
        title: '',
        crmCustomerId: customer?.crmCustomerId!,
        lastUpdated: moment.utc().format(),
      };
      tags.push(customerTags);
      tags.sort((x: CustomerTags, y: CustomerTags) => parseInt(x.tag) - parseInt(y.tag));
      formik.setFieldValue('customerTags', tags);
      const _index = tags.indexOf(customerTags);
      handlePopoverChipOpen(event, _index);
    };

    let customerNameObject: CustomerNameObject | undefined = undefined;
    if (customer) {
      customerNameObject = {
        customerNumber: formik.values?.customerNumber || 0,
        firstName: formik.values?.firstName || '',
        lastName: formik.values?.lastName || '',
        middleName: formik.values?.middleName || '',
        name: formik.values?.name || '',
        jobTitle: formik.values?.jobTitle,
        dateOfBirth: formik.values?.dateOfBirth,
        contactId: -1,
      };
    }
    function SetNameValues(customerName: CustomerNameObject) {
      formik.setFieldValue('name', customerName.name);
      formik.setFieldValue('firstName', customerName.firstName);
      formik.setFieldValue('middleName', customerName.middleName);
      formik.setFieldValue('lastName', customerName.lastName);
      formik.setFieldValue('customerNumber', customerName.customerNumber);
      //validateCustomerName(customerName);
    }
    const onNameSubmit = (customerName: CustomerNameObject) => {
      formik.setFieldValue('name', customerName.name);
      formik.setFieldValue('firstName', customerName.firstName);
      formik.setFieldValue('middleName', customerName.middleName);
      formik.setFieldValue('lastName', customerName.lastName);
      formik.setFieldValue('customerNumber', customerName.customerNumber);
      if (customerName.customerNumber.length > 0) {
        setIsFormSubmitted(false);
      }
      //validateCustomerName(customerName);
    };

    const validateCustomerName = (customerName: CustomerNameObject) => {
      if (dmsTypeId === 1) {
        return !!customerName.name;
      }
      const name = `${customerName.firstName} ${customerName.lastName}`.trimStart();
      return name.length > 0 || formik.values.isOrganization && (formik.values.organizationName?.trimStart().length ?? 0) > 0;
    };

    const onAddTaskBtn = () => dispatch(showTaskDrawer({ drawerType: 'TASK_ADD', drawerProps: { customer } }));

    // Commented the flag code, as currently not required
    // const ReviewFlag = ({ reviewFlag, onClick }: { reviewFlag: boolean; onClick: any }) => {
    //   return reviewFlag ? (
    //     <FlagIcon className={classes.flagIcon} color="error" fontSize="large" onClick={onClick} />
    //   ) : (
    //     <FlagOutlinedIcon className={classes.flagIcon} fontSize="large" onClick={onClick} />
    //   );
    // };

    useEffect(() => {
      if (formik.values.isOrganization && !customer) {
        formik.setFieldValue('name', '')
        formik.setFieldValue('firstName', '')
        formik.setFieldValue('middleName', '')
        formik.setFieldValue('lastName', '')
      } else if (!customer) {
        formik.setFieldValue('organizationName', '')
      }

    }, [formik.values.isOrganization])

    useEffect(() => {
      if (formik.values.isOrganization && !customer) {
        formik.setFieldValue('name', '')
        formik.setFieldValue('firstName', '')
        formik.setFieldValue('middleName', '')
        formik.setFieldValue('lastName', '')
      } else if (!customer) {
        formik.setFieldValue('organizationName', '')
      }

    }, [formik.values.isOrganization])

    return (
      phoneTypes &&
      emailTypes &&
      categories && (
        <form noValidate autoComplete="off" onSubmit={formik.handleSubmit}>
          {<div style={{ marginTop: '15px' }} />}
          <Grid container spacing={2} style={{ display: 'flex' }} justifyContent={'space-between'}>
            <Grid item xs={5} style={{ paddingRight: '0px' }} >
              {(((dmsTypeId == DmsTypeEnum.Aspen || dmsTypeId == DmsTypeEnum.DIS) && customer?.isOrganization)
                || customer?.isOrganization || !editMode) &&
                dmsTypeId != DmsTypeEnum.Infinity &&
                formik.values.isOrganization && (
                  <CompanyName formik={formik} formikErrors={formik.errors} editMode={editMode}></CompanyName>
                )}
              {((dmsTypeId != DmsTypeEnum.Ideal || !editMode || !customer?.isOrganization) && !(formik.values?.isOrganization && dmsTypeId == DmsTypeEnum.Ideal)) && !((dmsTypeId == DmsTypeEnum.Aspen || dmsTypeId == DmsTypeEnum.DIS) && formik.values.isOrganization)
                && (
                  <>
                    <CustomerNameComponent
                      SetisCustomerNumberUnique={SetisCustomerNumberUnique}
                      customerNameObject={customerNameObject}
                      crmCustomerId={formik.values.crmCustomerId}
                      formikErrors={formik.errors}
                      showfacebookIcon={customer?.FacebookCustomerId == null}
                      showNameFields={!formik.values?.isOrganization}
                      onFormSubmit={(e) => {
                        onNameSubmit(e);
                      }}
                      dmsTypeId={dmsTypeId}
                      SetNameObject={SetNameValues}></CustomerNameComponent>
                    {(dmsTypeId == DmsTypeEnum.Aspen || dmsTypeId == DmsTypeEnum.DIS) && !isCustomerNumberUnique && formik.values.customerNumber && <span style={{ marginLeft: '19px', fontWeight: 'bold', fontSize: 15 }} className={classes.errorMsg}></span>}
                  </>
                )}
              {isFormSubmitted && !!formik.errors?.customerNumber && <span style={{ marginLeft: '19px', fontWeight: 'bold', fontSize: 15 }} className={classes.errorMsg}>Customer ID Required</span>}
              <div style={{ flex: 1 }}></div>
              {/* Commented the flag code, as currently not required */}
              {/* {isReviewHubEnabled && (
              <ReviewFlag
                reviewFlag={formik.values.reviewFlag}
                onClick={() => {
                  formik.setFieldValue('reviewFlag', !formik.values.reviewFlag);
                }}
              />
            )*/}
            </Grid>
            {!customer && dmsTypeId !== DmsTypeEnum.Infinity && (
              <Grid item xs={2} style={{ padding: '0px', paddingTop: !editMode && (DmsTypeEnum.Aspen || DmsTypeEnum.Ideal || DmsTypeEnum.DIS) ? '10px' : '0px' }}>
                <Box display="flex" flexDirection="column" ml={2}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!formik.values.isOrganization}
                        onChange={() => {
                          formik.setFieldValue('isOrganization', false);
                        }}
                        size="small"
                      />
                    }
                    label="Customer"
                    style={{ marginBottom: '0px', marginTop: '-10px' }}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formik.values.isOrganization}
                        onChange={() => {
                          formik.setFieldValue('isOrganization', true);
                        }}
                        size="small"
                      />
                    }
                    label="Organization"
                    style={{ marginBottom: '0px', marginTop: '-10px' }}
                  />
                </Box>
              </Grid>
            )}
            <Grid item xs={3}>
              <TextField
                className={classes.textFieldPadding}
                select
                name="salesStageId"
                style={{ width: '150px' }}
                value={formik.values.salesStageId ?? 0}
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      className: classes.muiPopoverPaper,
                    },
                  },
                }}
                onChange={(event: any) => {
                  formik.setFieldValue('salesStageId', event.target.value);
                }}
                label="Customer Status"
                variant="outlined"
                size="small">
                {(salesStages.filter((s) => s.id !== -1)?.map((stage) => {
                  return (
                    <MenuItem key={stage.id} value={stage.id}>
                      {stage.salesStage}
                    </MenuItem>
                  );
                }))}
              </TextField>
            </Grid>
          </Grid>
          <hr style={{ marginTop: '15px' }} />
          <Box mt={1}>
            <Grid container spacing={2} alignItems="flex-start">
              {/* First Grid Section */}
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid
                    item
                    xs={6}
                    onClick={() => {
                      SetSummaryCount(summaryCount + 1);
                    }}
                  >
                    <SalesPerson formik={formik}></SalesPerson>
                  </Grid>

                  {editMode && (
                    <Grid item xs={6}>
                      <SurveyRating
                        surveyRating={customer?.lastSurveyRating}
                        surveyRatingDate={customer?.lastSurveyRatingDate}
                      ></SurveyRating>
                    </Grid>
                  )}
                  <Grid item xs={6}>
                    <Birthday formik={formik}></Birthday>
                  </Grid>
                  {((customer && editMode) || !editMode) && dmsTypeId !== 9 && (
                    <Grid item xs={6}>
                      <JobTitle formik={formik}></JobTitle>
                    </Grid>
                  )}
                  <Grid item xs={6}>
                    <CustomerCategoryComponent
                      formik={formik}
                      categories={categories}
                      catLoader={defaultCatLoader}
                      dmsType={dmsTypeId}
                    ></CustomerCategoryComponent>
                  </Grid>
                </Grid>
              </Grid>

            </Grid>
          </Box>


          <hr />
          <CustomerAddressList formik={formik} />
          <hr />
          <CustomerPhoneList
            formik={formik}
            phoneTypes={phoneTypes}
            dmsTypeId={dmsTypeId}
            customer={customer}
            convPhoneIds={customer?.conversationsPhoneIds}
            loading={phoneEmailLoader}
          />
          <hr />
          <CustomerEmailList formik={formik} emailTypes={emailTypes} dmsTypeId={dmsTypeId} loading={phoneEmailLoader} />
          <hr />
          <Notes formik={formik}></Notes>
          <hr />
          <Grid container spacing={1} justifyContent="space-between">
            <Grid item>
              <Grid container>
                <Grid item>
                  <StyleIcon style={{ marginTop: '-2px', marginRight: '5px' }} />
                </Grid>
                <Grid item>
                  <Typography variant="h5">Tags</Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Typography>
                <AddIcon
                  onClick={(e: any) => {
                    addNewTAg(e);
                  }}
                  style={{ cursor: 'pointer' }}
                />
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={0}>
            <Grid item xs={12} style={{ marginTop: '.5rem' }}>
              {formik.values.customerTags.map((x: CustomerTags, i: number) => (
                <>
                  <Chip
                    key={`tchip_${i}`}
                    size="small"
                    style={{ height: '45px', padding: '5px' }}
                    label={
                      <div
                        style={{
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          maxWidth: '110px',
                        }}>
                        <strong title={x.title}>{x.title}</strong> <br /> <span title={x.tag}>{x.tag}</span>
                      </div>
                    }
                    variant="filled"
                    onDelete={(e: any) => {
                      handleChipDelete(i);
                    }}
                    sx={{ margin: '2px' }}
                  />
                  <Popover
                    id={`popov_${i}`}
                    key={`popov_${i}`}
                    open={popoverChipState.openedPopoverId === i}
                    anchorEl={popoverChipState.anchorEl}
                    onClose={handlePopoverChipClose}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}>
                    <Box p={2} style={{ width: '300px' }}>
                      {/* <Grid container justifyContent="space-between">
                        <Grid item xs={12}>
                          <Autocomplete
                            options={customerTags || []}
                            getOptionLabel={(options) => options.tag}
                            onChange={(e: any) => {
                              formik.setFieldValue(`customerTags[${i}].tag`, e.target.textContent);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                variant="outlined"
                                autoFocus
                                margin="dense"
                                style={{ paddingTop: '5px', paddingBottom: '5px' }}
                                label="Add Tag"
                                onChange={(e: any) => {
                                  formik.setFieldValue(`customerTags[${i}].tag`, e.target.value);
                                }}
                                onKeyPress={(e) => {
                                  if (e.key === 'Enter') {
                                    handlePopoverChipClose();
                                  }
                                }}
                                value={x.tag}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <Box mt={1} ml={2}>
                            <Button
                              fullWidth
                              id="saveCustomerAddressBtn"
                              color="primary"
                              variant="contained"
                              size="medium"
                              onClick={() => {
                                handlePopoverChipClose();
                              }}>
                              Close
                            </Button>
                          </Box>
                        </Grid>
                      </Grid>                      */}

                      <Grid container justifyContent="space-between">
                        <CustomerTagPopover
                          formik={formik}
                          customerTags={customerTags}
                          setCustomerTags={setCustomerTags}
                          setPopoverChipState={setPopoverChipState}
                          chipIndex={i}></CustomerTagPopover>
                      </Grid>
                    </Box>
                  </Popover>
                </>
              ))}
            </Grid>
          </Grid>
          {customer && (
            <Grid container justifyContent="space-between" style={{ paddingTop: '30px', paddingBottom: '30px', paddingRight: '7px', paddingLeft: '7px' }}>
              {
                userPermissions.find((x) => x.featureName.toLowerCase() === "tasks") ?
                  <Grid item>
                    <td>
                      <LoadingButton
                        fullWidth
                        id="saveCustomerFormBtn"
                        color="primary"
                        variant="contained"
                        size="medium"
                        onClick={async () => {
                          onAddTaskBtn();
                        }}
                      >
                        Assign Tasks
                      </LoadingButton>
                    </td>
                  </Grid>
                  :
                  <></>
              }
              {
                userPermissions.find((x) => x.featureName.toLowerCase() === "deals") ?
                  <Grid item>
                    <td>
                      <LoadingButton
                        fullWidth
                        id="saveCustomerFormBtn"
                        color="primary"
                        variant="contained"
                        size="medium"
                        onClick={async () => {
                          setOpenAddDealDrawer(true);
                        }}
                      >
                        Create Deal
                      </LoadingButton>
                    </td>
                  </Grid>
                  :
                  <></>
              }

            </Grid>
          )}

          {openContactDrawer && (
            <CustomerContacts
              customer={customer}
              open={openContactDrawer}
              defaultPhoneType={formik.values.defaultPhoneType}
              convPhoneIds={customer?.conversationsPhoneIds}
              onClose={() => {
                SetOpenContactDrawer(false);
                reloadCustomerData(customer?.crmCustomerId!);
              }}
            />
          )}
          {/* {summaryCount > 4 || openSummaryDrawer && ( */}
          {openSummaryDrawer && (
            <CustomerSummaryDrawer
              dealerId={customer?.dealerId ?? 0}
              customerId={customer?.customerId ?? 0}
              isInvoiceAllowed={isInvoicePermission == 1 ? true : false}
              isMessengerAllowed={isMessengerPermission == 1 ? true : false}
              isTaskAllowed={isTaskPermission == 1 ? true : false}
              open={openSummaryDrawer}
              onClose={() => {
                SetOpenSummaryDrawer(false);
              }}></CustomerSummaryDrawer>
          )}
          {openAddDealDrawer && (
            <AddNewDeal
              renderDeals={() => { }}
              open={openAddDealDrawer}
              onClose={() => setOpenAddDealDrawer(false)}
              customer={customer}></AddNewDeal>
          )}
          <Box style={{ position: 'absolute', top: '3px', right: '80px' }}>
            {/* <Grid container spacing={2} direction="row" justifyContent="flex-end" alignItems="center"> */}
            {/* <Grid item>
              <Button id="OrderMessengerFormBtn" variant="contained" onClick={(event) => { SetOpenMessengerDrawer(true) }}>
                Messenger
              </Button>
              <Button id="OrderHistoryCustomerFormBtn" variant="contained" onClick={(event) => { SetOpenInvoiceDrawer(true) }}>
                Order History
              </Button>

            </Grid> */}

            {/* <Grid item>
              <Button id="cancelCustomerFormBtn" variant="contained" onClick={onClose}>
                Cancel
              </Button>

            </Grid> */}
            {/* <Grid item> */}

            <table cellPadding={0} cellSpacing={0} style={{ border: '0px solid silver' }}>
              <tr>
                <td style={{ verticalAlign: 'top', paddingTop: '0px' }}>
                  {typeof customer?.crmCustomerId !== 'undefined' &&
                    customer?.crmCustomerId != null &&
                    customer?.crmCustomerId > 0 && (
                      <Box style={{ border: '1px solid silver', padding: '0px 2px' }}>
                        <Box display="flex" alignItems="flex-start">
                          {/* Summary */}
                          <Box
                            sx={{ display: 'inline-flex', padding: '1px 2px' }}
                            className={classes.myTab}
                            style={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start' }}
                            onClick={() => SetOpenSummaryDrawer(true)}
                          >
                            <SummarizeIcon color="primary" />
                            <div style={{ fontSize: 'small', textAlign: 'center', marginTop: 2 }}>Summary</div>
                          </Box>

                          {/* Contacts */}
                          <Box
                            sx={{ display: 'inline-flex', padding: '1px 2px' }}
                            className={classes.myTab}
                            style={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start' }}
                            onClick={() => SetOpenContactDrawer(true)}
                          >
                            <ContactMailIcon color="primary" />
                            <div style={{ fontSize: 'small', textAlign: 'center', marginTop: 2 }}>Contacts</div>
                          </Box>

                          {/* Orders */}
                          {isInvoicePermission === 1 && (
                            <Box
                              sx={{ display: 'inline-flex', padding: '1px 2px' }}
                              className={classes.myTab}
                              style={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start' }}
                              onClick={() => SetOpenInvoiceDrawer(true)}
                            >
                              <HistoryIcon color="primary" />
                              <div style={{ fontSize: 'small', textAlign: 'center', marginTop: 2 }}>Orders</div>
                            </Box>
                          )}

                          {/* Text */}
                          {isMessengerPermission === 1 && (
                            <Box
                              sx={{ display: 'inline-flex', padding: '1px 2px' }}
                              className={classes.myTab}
                              style={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start' }}
                              onClick={() => SetOpenMessengerDrawer(true)}
                            >
                              <MailIcon color="primary" />
                              <div style={{ fontSize: 'small', textAlign: 'center', marginTop: 2 }}>Text</div>
                            </Box>
                          )}

                          {/* Owned Units */}
                          <Box
                            sx={{ display: "inline-flex", padding: "1px 2px" }}
                            className={classes.myTab}
                            style={{ flexDirection: "column", alignItems: "center", justifyContent: "flex-start" }}
                            onClick={handleOwnedUnitsClick}
                          >
                            <AgricultureIcon color="primary" />
                            <div style={{ fontSize: "small", textAlign: "center", marginTop: 2 }}>Owned Units</div>
                          </Box>
                        </Box>
                      </Box>
                    )}
                </td>

                {/* Save button */}
                <td style={{ paddingLeft: '5px', paddingTop: '0px', verticalAlign: 'top' }}>
                  {(dmsTypeId !== DmsTypeEnum.DIS || (dmsTypeId === DmsTypeEnum.DIS && editDISMode)) && (
                    <LoadingButton
                      fullWidth
                      id="saveCustomerFormBtn"
                      color="primary"
                      variant="contained"
                      size="medium"
                      onClick={() => {
                        console.log(formik.errors);
                        setIsFormSubmitted(true);
                        formik.handleSubmit();
                      }}
                    >
                      Save
                    </LoadingButton>
                  )}
                </td>
              </tr>
            </table>


            {/* </Grid> */}
            {/* </Grid> */}
          </Box>
          <CustomerInvoiceDrawer
            open={openInvoiceDrawer}
            onClose={handleInvoiceDrawerClose}
            invoiceId={0}
            dealerId={customer?.dealerId}
            invoiceRow={[]}
            crmCustomerId={customer?.crmCustomerId}>
            {/* Don't Delete This Line*/}
          </CustomerInvoiceDrawer>

          {openMessengerDrawer && (
            <MessengerDrawer
              defaultSearch={'CrmCustomerId:' + customer?.crmCustomerId.toString()}
              phoneNumber={customer?.defaultPhoneNumberForMessenger}
              open={openMessengerDrawer}
              onClose={() => {
                SetOpenMessengerDrawer(false);
                reloadCustomerData(customer?.crmCustomerId!);
              }}></MessengerDrawer>
          )}

          {openOwnedUnitsDrawer && (
            <OwnedUnitsDrawer
              open={openOwnedUnitsDrawer}
              onClose={() => setOpenOwnedUnitsDrawer(false)}
              customerId={customer?.customerId ?? 0}
              onNoRecords={() => {
                setShouldShowNoUnitsDialog(true);
                setOpenOwnedUnitsDrawer(false);
              }}
            />
          )}
          {openNoUnitsDialog && (
            <Dialog
              open={openNoUnitsDialog}
              onClose={() => {
                setOpenNoUnitsDialog(false);
                setOpenOwnedUnitsDrawer(false);
              }}
              disableEnforceFocus
              disableAutoFocus
              disableRestoreFocus
            >
              <DialogTitle>No Owned Units</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  This customer doesn’t have any owned units.
                </DialogContentText>
              </DialogContent>
            </Dialog>
          )}
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme: any) => theme.zIndex.drawer + 2 }}
            open={loadingOwnedUnits}
          >
            <CircularProgress color="inherit" />
          </Backdrop>

        </form>
      )
    );


    function handleInvoiceDrawerClose() {
      SetOpenInvoiceDrawer(false);
    }
  },
);
export default CustomerForm;